// Maps the trip's currency code (as returned by the API, e.g. "USD" / "UYU")
// to the symbol we show next to amounts across the app.
const CURRENCY_SYMBOLS = {
  USD: "U$S",
  UYU: "$",
};

export const getCurrencySymbol = (currency) =>
  CURRENCY_SYMBOLS[currency?.toUpperCase()] || currency || "U$S";
